import React, { useEffect, useRef, useState } from 'react';
import { getPublicUrl } from '../../../appconfig';
import { getContentType } from '../../../Utils/helper';
import {
  BannerTitle,
  GridWrapper,
} from '../../StoreHomePage/BannersGrid/styled';
import { HelpfulTools, ToolName, ToolsContainer, ToolsList } from './styled';
import { useRouter } from 'next/router';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default React.memo(function ParentingHelpfulTools(props) {
  const { data, stage } = props;
  const [toolsSignal, setToolsSignal] = useState(' ');
  const router = useRouter();
  const toolsRef = useRef();
  const toolsClickHandler = (item) => {
    if (item.id == 13) {
      window.location.href = `${getPublicUrl()}/store/babyexpendeture${
        window.location.search
      }`;
    } else if (item && item?.value != null) {
      let redirection_url = getPublicUrl() + item?.value;
      if (item?.value?.includes('https://')) {
        redirection_url = item?.value;
      }
      window.location.href = redirection_url + window.location.search;
    }
  };
  useEffect(() => {
    if (data?.items?.length > 0) {
      let cardId = [];
      data?.items?.forEach((element) => {
        element?.items?.map((item) => {
          if (item?.value && (item?.type == 1 || item?.id == 52))
            cardId.push(item?.id);
        });
      });
      fireServedSectionEvent(data?.heading, cardId, getContentType());
    }
    const query = router.query;
    const { tools } = query;
    if (tools) {
      const toolsSection = toolsRef.current;
      if (toolsSection)
        toolsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
    }
  }, []);

  return (
    <GridWrapper ref={toolsRef}>
      <BannerTitle>
        <h2>{data?.heading}</h2>
      </BannerTitle>
      <HelpfulTools stage={stage}>
        {data?.items?.map((item, index) => {
          return (
            <div key={`toollist_${index}`} className="tools_grid">
              <BannerTitle>
                <h3>{item?.title}</h3>
              </BannerTitle>
              <ToolsContainer stage={stage}>
                {item?.items.map((element, index) => {
                  if (
                    element?.value &&
                    (element?.type == 1 || element?.id == 52)
                  ) {
                    return (
                      <ToolsList
                        stage={stage}
                        className={
                          element?.value + index === toolsSignal.index &&
                          toolsSignal.className
                        }
                        onClick={() => {
                          (fireClickedCardEvent(
                            data?.heading,
                            element?.name,
                            getContentType(),
                            element?.id,
                            null,
                            element?.value,
                          ),
                            setTimeout(() => {
                              toolsClickHandler(element);
                            }, 200));
                          setToolsSignal({
                            className: 'toolEffect',
                            index: element?.value + index,
                          });
                        }}
                        key={`tools_${index}`}
                      >
                        <img
                          src={element?.image}
                          srcSet={`${element?.image}?tr=w-60,q-80 60w, ${element?.image}?tr=w-66,q-80 66w`}
                          sizes="(max-width: 720px) 60px, 66px"
                          alt={element?.name?.toLowerCase()}
                          loading="lazy"
                        />
                        <ToolName>{element?.name?.toLowerCase()}</ToolName>
                      </ToolsList>
                    );
                  }
                })}
              </ToolsContainer>
            </div>
          );
        })}
      </HelpfulTools>
    </GridWrapper>
  );
});
